module.exports = __webpack_public_path__ + "img/eye_gray.5cc1c763.svg";